// Utility functions for fetching and parsing data

/**
 *
 * @param str String with alleged json
 * @param validate Function to validate the data structure
 * @param error Function invoked when parsing fails
 * @returns Parsed data or null
 */
export const tryParse = <T>(
  str: string | null,
  validate: (t: any) => boolean = () => true,
  error?: (str: string) => void
): T | null => {
  if (str !== null) {
    try {
      const value = JSON.parse(str);
      if (validate(value)) return value;
    } catch {
      error?.(str);
    }
  }

  return null;
};
